var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFloating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000000902726508368768610000001799399489752732850_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 229.4 117.9",
    style: {
      enableBackground: "new 0 0 229.4 117.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EC1A15;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.2,35c-8,8.5-16,17-24.1,25.5C59,79.5,41,98.5,23,117.6c-0.1,0.1-0.2,0.2-0.3,0.3H0.2 c0.4-1.9,1.5-3.8,3.4-5.7c27.9-29.5,55.8-58.9,83.7-88.4c3.5-3.7,7-4.8,10.7-3.3C103.9,22.8,105.5,30.2,101.2,35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M186.6,117.9h-25.3c-10.2-9.5-20.3-19-30.7-28.7c-1.8,1.9-3.5,3.8-5.3,5.5c-7.7,7.8-15.4,15.5-23.1,23.2 H83.7c-0.9-3.1,0-6.6,2.7-9.3c12.4-12.4,24.7-24.9,37.1-37.3c4.4-4.4,9.3-4.5,13.7-0.3c15.7,14.7,31.4,29.3,47.1,44 C185.3,115.9,186.1,116.9,186.6,117.9L186.6,117.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.4,116.8c0.2,0.4,0.5,0.7,0.6,1.1h-16.8c0.7-0.7,1.4-1.4,2.1-2.1C134.7,111.5,141.2,112,144.4,116.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M229.4,117.9h-21.7c-26-24.6-51.7-49-77.8-73.7C107.6,67.7,85.4,91.1,63,114.7c1.2,1.1,2.3,2.1,3.4,3.2H42.1 c-1.2-3.2-0.3-6.5,2.7-9.6c25.9-27.4,51.9-54.7,77.9-82.1c4.3-4.5,9.4-4.6,13.9-0.3c29.9,28.3,59.7,56.6,89.6,84.9 C228.4,112.9,229.5,115.4,229.4,117.9L229.4,117.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.1,10.8C100,4.8,104.8,0,110.8,0s10.8,4.7,10.8,10.7s-4.7,10.6-10.6,10.7C105,21.4,100.2,16.8,100.1,10.8 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFloating);
export default __webpack_public_path__ + "static/media/logo-floating.d5067e7cce2ae2d9c7b643d5b964bb27.svg";
export { ForwardRef as ReactComponent };